import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Droplets, Flame, Waves, Bath, Building2, ShieldCheck,
  BadgeCheck, Receipt, Star, Home, Landmark, ThumbsUp,
  Award, Gem, FileCheck, Play, X, Phone, CalendarCheck, Mail,
} from 'lucide-react';
import {
  company, trustItems, services, whyItems, stats,
  heroImage, heroVideoId, heroBadge, heroChecks,
} from '../mock';

const iconMap = {
  Droplets, Flame, Waves, Bath, Building2, ShieldCheck,
  BadgeCheck, Receipt, Star, Home, Landmark, ThumbsUp, Award, Gem, FileCheck,
};
const Ic = ({ name, ...rest }) => {
  const C = iconMap[name] || Droplets;
  return <C {...rest} />;
};

export function Hero() {
  const [video, setVideo] = useState(false);
  return (
    <section className="hero" id="top">
      <div className="wrap">
        <div className="hero-grid">
          <div>
            <span className="hero-badge"><span className="ic"><Award size={15} /></span>{heroBadge}</span>
            <h1>Your expert Savannah plumber, <em>built on integrity &amp; high standards</em></h1>
            <p className="lede">
              Founded by lifelong Savannahian and Class II Master Plumber {company.founder} and his wife
              Kelley Hagemes, Victory Plumbing is a customer-centered, family-owned company offering a
              different caliber of service to Savannah and the surrounding Coastal Empire &mdash;
              residential, commercial &amp; industrial.
            </p>
            <div className="cta-row">
              <Link className="btn btn-gold" to="/contact"><Mail size={16} /> Get in Touch</Link>
              <a className="btn btn-outline" href={company.phoneHref}><Phone size={15} /> {company.phoneDisplay}</a>
            </div>
            <div className="hero-checks">
              {heroChecks.map((c) => (
                <div className="hc" key={c.t}><span className="ic"><Ic name={c.icon} size={17} /></span>{c.t}</div>
              ))}
            </div>
          </div>
          <div className="hero-media">
            <div className="frame">
              <img src={heroImage} alt="Victory Plumbing technician at work" loading="eager" />
              <button className="play-btn" aria-label="Play intro video" onClick={() => setVideo(true)}>
                <Play size={26} fill="currentColor" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="ridge dark" />

      {video && (
        <div className="video-modal" onClick={() => setVideo(false)}>
          <div className="vwrap" onClick={(e) => e.stopPropagation()}>
            <button className="vclose" onClick={() => setVideo(false)}><X size={16} /></button>
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${heroVideoId}?autoplay=1`}
              title="Victory Plumbing intro"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
}

export function TrustStrip() {
  return (
    <div className="trust">
      <div className="wrap">
        {trustItems.map((t) => (
          <div className="tcard" key={t.t}>
            <span className="ring"><Ic name={t.icon} size={24} strokeWidth={1.4} /></span>
            <div className="t">{t.t}</div>
            <div className="s">{t.s}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Services() {
  return (
    <section id="services">
      <div className="wrap">
        <div className="sec-head reveal">
          <p className="eyebrow">What We Do</p>
          <h2>A wide range of services, done right</h2>
          <p>Backed by experience with an individualized approach to your concerns and budget &mdash; every job fulfilled in compliance to code and constructed to last, major or minor.</p>
        </div>
        <div className="svc-grid reveal">
          {services.map((s) => (
            <div className="svc-card" key={s.title}>
              <div className="svc-top">
                <span className="svc-ic"><Ic name={s.icon} size={24} strokeWidth={1.4} /></span>
                <h3>{s.title}</h3>
              </div>
              <p>{s.desc}</p>
              <ul>
                {s.items.map((i) => <li key={i}>{i}</li>)}
              </ul>
            </div>
          ))}
        </div>
        <div className="svc-actions">
          <Link className="btn btn-gold" to="/contact"><Mail size={16} /> Get in Touch</Link>
          <a className="btn btn-outline-dark" href={company.phoneHref}><Phone size={15} /> Call Us</a>
        </div>
      </div>
    </section>
  );
}

export function WhyUs() {
  return (
    <section className="why on-dark" id="about">
      <div className="wrap">
        <div className="sec-head">
          <p className="eyebrow">Why Victory Plumbing?</p>
          <h2 style={{ color: 'var(--ivory)' }}>Plumbing you can trust</h2>
          <p>Founded by lifelong Savannahian {company.founder} and his family in {company.founded}, we take pride in our work &mdash; and above all, we stand by it.</p>
        </div>
        <div className="why-cards">
          {whyItems.map((w) => (
            <div className="why-card" key={w.h}>
              <span className="ic-sq"><Ic name={w.icon} size={22} strokeWidth={1.4} /></span>
              <h4>{w.h}</h4>
              <p>{w.p}</p>
            </div>
          ))}
        </div>
        <div className="stat-strip">
          {stats.map((s) => (
            <div key={s.label}>
              <div className="num">{s.num}</div>
              <div className="label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
